@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';

@border: 1px solid @scan-page--item-list-row--border-color;

.cell {
  height: 100%;
  display: flex;
  align-items: center;
  border-bottom: @border;

  /* last column of every row with .cell */
  &.last {
    padding-right: 5px;
    background-color: @scan-page--item-list-last-row--background-color;
  }

  &.counts {
    border-left: 1px solid @scan-page--item-list-row-counts--border-color;
  }

  &.verified {
    background-color: @scan-page--item-list-verified-row--background-color;
    color: @scan-page--item-list-verified-row--text-color;
  }

  &.info-and-buttons {
    display: flex;
    justify-content: space-between;
    border-right: none;
  }

  &.scan-to-print {
    padding-right: 0;
  }
}
